

























import { Component, Prop, Vue } from "vue-property-decorator";

const MODULOS = [
  [
    2,
    "A ciência na Prática",
    "Aqui, é o momento de conhecer os Números Mestres e a Árvore da Vida, para compreender as suas Partes para você entender o ser humano de forma profunda."
  ],
  [
    3,
    "A Jornada até o Destino",
    "Esse é o ápice do treinamento para compreender o seu destino e descobrir o seu Propósito de Vida."
  ]
];

const MODULO = [
  [
    1,
    "Teoria de Pitágoras para a entender a vida",
    "Você vai descobrir a facilidade e a satisfação de se relacionar consigo mesmo e com as outras pessoas de uma forma leve, autêntica e verdadeira respeitando a liberdade e a vontade de cada um. Além disso, vai aprender técnicas de autoconhecimento e encontrar um caminho essencial para a qualidade de vida emocional, mental, física e espiritual. Vai também entender a numerologia pitagórica, a simbologia dos números e como transformar letras em números."
  ]
];

@Component
export default class extends Vue {
  modulos: Array<Modulo> = [];

  mounted() {
    this.modulos = MODULOS.map(function(modulo) {
      return new Modulo(modulo[0], modulo[1], modulo[2]);
    });
  }
}

class Modulo {
  numero: any;
  subtitulo: any;
  descricao: any;
  constructor(numero: any, subtitulo: any, descricao: any) {
    this.numero = numero;
    this.subtitulo = subtitulo;
    this.descricao = descricao;
  }
}
